<script>
import LocaleSelect from '@components/locale-select'
import { mapGetters } from 'vuex'
export default {
  components: { LocaleSelect },
  computed: {
    ...mapGetters('brokerage', ['brokerage_info']),
  },
  mounted() {
    document.body.classList.add(this.$style.bodyAdmin)
  },
  beforeDestroy() {
    document.body.classList.remove(this.$style.bodyAdmin)
  },
}
</script>

<template>
  <div :class="[$style.ec, $style.adminRoot]">
    <div :class="[$style.header]">
      <h1 :class="[$style.xeAdmin]"
        ><a href="#" @click.prevent>{{ brokerage_info.title }}</a></h1
      >

      <ul :class="[$style.gnb]">
        <li>
          <LocaleSelect></LocaleSelect>
        </li>
        <li
          ><router-link :to="{ name: 'logout' }" :class="[$style.link]">{{
            $t('admin_main.sign_out')
          }}</router-link></li
        >
      </ul>
      <ul v-if="0" :class="[$style.lnb]">
        <li :class="[$style.core, $style.selected]"
          ><a href="#">{{ $t('admin_main.control_panel') }}</a></li
        >
        <li :class="[$style.core]"
          ><a href="#">{{ $t('admin_main.board') }}</a></li
        >
      </ul>
    </div>
    <hr />
    <div :class="[$style.body]">
      <div :class="[$style.extension, $style.e1]">
        <div :class="[$style.section]">
          <div :class="$style.searchNav">
            <input type="text" size="12" />
            <button type="button"></button>
          </div>
          <ul :class="[$style.navigation]">
            <li :class="[$style.parent, $style.active, $style.module_service]">
              <a href="#" :class="[$style.parent]">{{
                $t('brokerage_console_main.pr_affiliate')
              }}</a>
              <ul>
                <li>
                  <router-link
                    :to="{ name: 'brokerage-console-index' }"
                    :active-class="$style.active"
                    >{{
                      $t('brokerage_console_main.brokerage_catalog')
                    }}</router-link
                  >
                </li>
                <li>
                  <router-link
                    :to="{ name: 'brokerage-console-child-list' }"
                    :active-class="$style.active"
                    >{{ $t('brokerage_console_main.sub_broker') }}</router-link
                  >
                </li>
                <li>
                  <router-link
                    :to="{ name: 'brokerage-console-relation-list' }"
                    :active-class="$style.active"
                    >{{
                      $t('brokerage_console_main.relation_list')
                    }}</router-link
                  >
                </li>
                <li>
                  <router-link
                    v-if="0"
                    :to="{ name: 'brokerage-console-member-list' }"
                    :active-class="$style.active"
                    >{{
                      $t('brokerage_console_main.affiliated_member')
                    }}</router-link
                  >
                </li>
                <li>
                  <router-link
                    :to="{ name: 'brokerage-console-pg-merchant-list' }"
                    :active-class="$style.active"
                    >귀속 상점</router-link
                  >
                </li>
                <li>
                  <router-link
                    v-if="0"
                    :to="{ name: 'brokerage-console-outsite-transaction-list' }"
                    :active-class="$style.active"
                    >{{
                      $t('brokerage_console_main.external_site_transaction')
                    }}</router-link
                  >
                </li>
                <li v-if="0">
                  <router-link
                    :to="{ name: 'brokerage-console-balance-list' }"
                    :active-class="$style.active"
                    >{{
                      $t('brokerage_console_main.brokerage_balance')
                    }}</router-link
                  >
                </li>
                <li>
                  <router-link
                    :to="{ name: 'brokerage-console-share-list' }"
                    :active-class="$style.active"
                    >{{
                      $t('brokerage_console_main.brokers_equity')
                    }}</router-link
                  >
                </li>
                <li v-if="0">
                  <router-link
                    :to="{ name: 'brokerage-console-adjust-list' }"
                    :active-class="$style.active"
                    >{{
                      $t('brokerage_console_main.brokerage_settlement')
                    }}</router-link
                  >
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
      <hr />
      <div :class="[$style.content]">
        <p :class="[$style.path]">
          <a href="#">{{ $t('admin_main.admin') }}</a>
        </p>
        <slot />
      </div>
    </div>
    <hr />
    <div :class="[$style.footer]">
      <address
        ><a href="#">Powered by <strong>X</strong>change</a></address
      >
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@src/design/default.scss';
@import '@src/design/layout.scss';
@import '@src/design/admin.scss';
@import '@src/design/font.scss';

.bodyAdmin {
  background-color: transparent;
}
.bodyAdmin select {
  appearance: menulist;
}
.link {
  font-size: 14px !important;
  line-height: 2.2;
  color: #fff !important;
}
</style>
